import type { ButtonHTMLAttributes, ReactNode } from 'react'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger'
  size?: 'sm' | 'md'
  icon?: ReactNode
  title?: string
}

const VARIANTS: Record<NonNullable<ButtonProps['variant']>, string> = {
  primary:
    'bg-accent-red text-white hover:bg-[#ff6572] disabled:bg-ink-surface2 disabled:text-text-faint',
  secondary:
    'bg-ink-surface2 text-text border border-ink-border hover:border-white/20 disabled:opacity-40',
  ghost: 'bg-transparent text-text-muted hover:text-text hover:bg-white/5 disabled:opacity-40',
  danger: 'bg-transparent text-accent-red border border-accent-red/40 hover:bg-accent-red/10',
}

const SIZES: Record<NonNullable<ButtonProps['size']>, string> = {
  sm: 'text-xs px-2.5 py-1.5 gap-1.5',
  md: 'text-sm px-3.5 py-2 gap-2',
}

export function Button({
  variant = 'secondary',
  size = 'md',
  icon,
  className = '',
  children,
  disabled,
  ...rest
}: ButtonProps) {
  return (
    <button
      className={`inline-flex items-center justify-center rounded font-medium transition-colors disabled:cursor-not-allowed ${VARIANTS[variant]} ${SIZES[size]} ${className}`}
      disabled={disabled}
      {...rest}
    >
      {icon}
      {children}
    </button>
  )
}
